import { Utils } from "../helpers/utils";
import { StoreManager } from "../helpers/store";

/*
    If you ever need to make something "sticky"
    this class should do the trick.
*/

export class StickyElements{

    static prefix = "zaux";
    static moduleName = "stickyElements";
    static selectorName = `data-${this.prefix}-sticky-element`;
    static selector = `[${this.selectorName}]`;
    static deltaCSSVarName = `--sticky-delta-sub`;
    static contentSelectorName = `data-${this.prefix}-sticky-content`;
    static startSelectorName = `data-${this.prefix}-sticky-start`;
    static endSelectorName = `data-${this.prefix}-sticky-end`;
    static contentSelector = `[${this.contentSelectorName}]`;
    static startSelector = `[${this.startSelectorName}]`;
    static endSelector = `[${this.endSelectorName}]`;
    static adjustOffsetDelay = 2000;
    
    static setupStickyElements(){
        if (document.querySelectorAll(this.selector).length > 0) {
            document.querySelectorAll(this.selector).forEach(element => {
                
                var windowOffsetBottom = window.scrollY + window.innerHeight;
                var startMarker = element.querySelector(this.startSelector);
                var endMarker = element.querySelector(this.endSelector);
                var content = element.querySelector(this.contentSelector);

                content.style.position = "relative";
                element.style.setProperty( this.deltaCSSVarName, window.scrollY + startMarker.getBoundingClientRect().top + "px" );

                 var updateDelta = () => {
                    var deltaHeight = window.scrollY + startMarker.getBoundingClientRect().top;
                    deltaHeight = deltaHeight - window.scrollY;
                    if( deltaHeight <= StoreManager.getState("appHeader").instance.height() ){
                        deltaHeight = StoreManager.getState("appHeader").instance.height();
                    }
                    element.style.setProperty(this.deltaCSSVarName, deltaHeight + 'px');
                };

                var updateContentPosition = () => {
                    var startOffset = startMarker.getBoundingClientRect().top + window.scrollY;
                    var endOffset = endMarker.getBoundingClientRect().top + window.scrollY - content.clientHeight;
                    var scrollTop = window.scrollY;
                    var headerHeight = StoreManager.getState("appHeader").instance.height();

                    if (scrollTop + headerHeight > startOffset && scrollTop + headerHeight < endOffset) {
                        content.style.top = (scrollTop + headerHeight - startOffset) + 'px';
                    } else if (scrollTop + headerHeight <= startOffset) {
                        content.style.top = '0px';
                    } else {
                        content.style.top = (endOffset - startOffset) + 'px';
                    }
                };
                
                updateContentPosition();
                window.addEventListener("scroll", updateContentPosition);

                updateDelta();
                window.addEventListener("scroll", updateDelta);
                window.addEventListener("resize", updateDelta);
                
            });
        }
    }

    static init(){
        if( Utils.isDebug ){
            console.log(`Module "${this.moduleName}" started...`);
        }
        this.setupStickyElements();
        Utils.getNS().modules.stickyElements = this;
    }

}